import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '@common/services/AuthService/AuthService';
import { EmployeeService } from '@common/services/EmployeeService/EmployeeService';
import { SortableTableComponent } from '@common/components/SortableTableComponent/sortableTable.component';
import { ModalService } from '@common/services/ModalService/ModalService';
import { EmployeesData } from '@common/models/employeesData.model';
import { Employee } from '@common/models/employee.model';
import { QueryParameters } from '@common/models/queryParameters.model';
import { QueryParametersUpdate } from '@common/models/queryParametersUpdate.model';

@Component({
  templateUrl: './employeesView.component.html',
  styleUrls: ['./employeesView.component.scss'],
})
export class EmployeesViewComponent implements OnInit {
  employeesData: EmployeesData = {
    employees: [],
    employeesNumber: 0,
  };
  queryParameters: QueryParameters = {
    query: '',
    orderBy: '',
    sortOrder: 'ASC',
    page: 1,
  };
  dataFetchingTimeout;
  @ViewChild('employeesTableComponent') employeesTableComponent: SortableTableComponent;

  public fields = [
    { shortName: 'employeeName', fullName: 'name', type: 'string', sortable: true, width: '30%' },
    { shortName: 'employeePhone', fullName: 'phone', type: 'string', sortable: true, width: '29%' },
    {
      shortName: 'clientsAssigned',
      fullName: 'clientsAssigned',
      type: 'link-set',
      sortable: false,
      prefix: '/clients',
      fieldKey: 'clientKey',
      fieldName: 'clientName',
      width: '30%',
    },
  ];

  constructor(
    public router: Router,
    public authService: AuthService,
    public employeeService: EmployeeService,
    public modalService: ModalService,
  ) {}

  ngOnInit() {
    this.getViewData();
  }

  getViewData(): void {
    this.employeeService.getEmployees(this.queryParameters)
      .subscribe(
        (data: EmployeesData) => {
          this.employeesData = data;

          if (this.employeesTableComponent) {
            this.employeesTableComponent.hideSpinner();
          }
        },
        error => this.authService.handleRequestError(error, this.getViewData.bind(this)),
      );
  }

  onParametersUpdated($event: QueryParametersUpdate): void {
    this.queryParameters = Object.assign(this.queryParameters, $event);
    this.getDataWithTimeout(this.getViewData.bind(this));
  }

  getDataWithTimeout(fn): void {
    clearTimeout(this.dataFetchingTimeout);
    this.dataFetchingTimeout = setTimeout(fn, 500);
  }

  deleteEmployee(employee: Employee): void {
    const proceedEmployeeDeletion = () => {
      this.modalService.closeModal();
      this.employeeService.deleteEmployee(employee.employeeKey)
        .subscribe(
          (res: null) => {
            this.modalService.openModal({ type: 'employeeDeleted' });
            this.getViewData();
          },
          (err) => {
            this.modalService.openModal({ type: 'errorOccurred' });
          },
        );
    };

    this.modalService.openModal({
      type: 'deleteEmployee',
      data: {
        employeeName: employee.employeeName,
      },
      callback: proceedEmployeeDeletion,
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/employees/views/employeesView/employeesView.component.ts